import { SigninAuthenticationModel } from "@factory/model/query-model-authentication";
import { CreateServiceModel } from "@factory/model/query-model-service";
import { UpdateServiceModel } from "@factory/model/query-model-service";
import { DeleteServiceModel } from "@factory/model/query-model-service";
import { CreateTenantModel } from "@factory/model/query-model-tenant";
import { UpdateTenantModel } from "@factory/model/query-model-tenant";
import { DeleteTenantModel } from "@factory/model/query-model-tenant";
import {
  CreatePersonModel,
  CreatePersonModelExtension,
  UpdatePersonModelExtension,
} from "@factory/model/query-model-person";
import { UpdatePersonModel } from "@factory/model/query-model-person";
import { DeletePersonModel } from "@factory/model/query-model-person";
import { CreateRoleModel } from "@factory/model/query-model-role";
import { UpdateRoleModel } from "@factory/model/query-model-role";
import { DeleteRoleModel } from "@factory/model/query-model-role";
import {
  CreateMemberModel,
  CreateMemberModelExtension,
  UpdateMemberModelExtension,
} from "@factory/model/query-model-member";
import { UpdateMemberModel } from "@factory/model/query-model-member";
import { DeleteMemberModel } from "@factory/model/query-model-member";
import { CreateTransactionServiceModel } from "@factory/model/query-model-transaction-service";
import { UpdateTransactionServiceModel } from "@factory/model/query-model-transaction-service";
import { DeleteTransactionServiceModel } from "@factory/model/query-model-transaction-service";
import { CreateTransactionAddonModel } from "@factory/model/query-model-transaction-addon";
import { UpdateTransactionAddonModel } from "@factory/model/query-model-transaction-addon";
import { DeleteTransactionAddonModel } from "@factory/model/query-model-transaction-addon";
import { CreateTransactionModel } from "@factory/model/query-model-transaction";
import { UpdateTransactionModel } from "@factory/model/query-model-transaction";
import { DeleteTransactionModel } from "@factory/model/query-model-transaction";
import { CreateItemModel } from "@factory/model/query-model-item";
import { UpdateItemModel } from "@factory/model/query-model-item";
import { DeleteItemModel } from "@factory/model/query-model-item";
import { CreateWaiverModel } from "@factory/model/query-model-waiver";
import { UpdateWaiverModel } from "@factory/model/query-model-waiver";
import { DeleteWaiverModel } from "@factory/model/query-model-waiver";
import {
  CreateTransactionWaiverModel,
  CreateTransactionWaiverModelExtension,
  UpdateTransactionWaiverModelExtension,
} from "@factory/model/query-model-transaction-waiver";
import { UpdateTransactionWaiverModel } from "@factory/model/query-model-transaction-waiver";
import { DeleteTransactionWaiverModel } from "@factory/model/query-model-transaction-waiver";
import { CreateSubscriptionModel } from "@factory/model/query-model-subscription";
import { UpdateSubscriptionModel } from "@factory/model/query-model-subscription";
import { DeleteSubscriptionModel } from "@factory/model/query-model-subscription";
// MAPPER QUERY MODEL IMPORT

import {
  LoginFormSchema,
  ServiceFormSchema,
  TenantFormSchema,
  PersonFormSchema,
  RoleFormSchema,
  MemberFormSchema,
  TransactionServiceFormSchema,
  TransactionAddonFormSchema,
  TransactionFormSchema,
  ItemFormSchema,
  WaiverFormSchema,
  TransactionWaiverFormSchema,
  SubscriptionFormSchema,
  // MAPPER IMPORT
} from "../form/form.rule";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { format } from "date-fns";

export function useFormApiMapper() {
  const { formatDate, getDateTimeLocal } = useDateTimeContext();

  const mapLogin = (form: LoginFormSchema) => {
    const payload = {
      username: form.username,
      password: form.password,
    } as SigninAuthenticationModel;

    return payload;
  };

  const mapCreateService = (form: ServiceFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
      amount: form.amount,
      duration: form.duration,
      is_open_time: form.isOpenTime,
      upgrade: form.upgrade,
      is_active: form.isActive,
      is_subscription: form.isSubscription,
      days: form.days,
      tenant: form.tenant,
    } as CreateServiceModel;

    return payload;
  };
  const mapUpdateService = (form: ServiceFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
      amount: form.amount,
      duration: form.duration,
      is_open_time: form.isOpenTime,
      upgrade: form.upgrade,
      is_active: form.isActive,
      is_subscription: form.isSubscription,
      days: form.days,
      tenant: form.tenant,
    } as UpdateServiceModel;

    return payload;
  };
  const mapDeleteService = (code: string) => {
    const payload = {
      code,
    } as DeleteServiceModel;

    return payload;
  };
  const mapCreateTenant = (form: TenantFormSchema) => {
    const payload = {
      owner: form.owner,
      business_name: form.businessName,
      business_type: form.businessType,
      description: form.description,
      avatar: form.avatar,
      email: form.email,
      mobile_number: form.mobileNumber,
      phone: form.phone,
      website: form.website,
      //   membership_date: formatDate(form.membershipDate as Date, undefined),
      rewards_type: form.rewardsType,
    } as CreateTenantModel;

    return payload;
  };
  const mapUpdateTenant = (form: TenantFormSchema, code: string) => {
    const payload = {
      code,
      owner: form.owner,
      business_name: form.businessName,
      business_type: form.businessType,
      description: form.description,
      avatar: form.avatar,
      email: form.email,
      mobile_number: form.mobileNumber,
      phone: form.phone,
      website: form.website,
      //   membership_date: formatDate(form.membershipDate as Date, undefined),
      rewards_type: form.rewardsType,
    } as UpdateTenantModel;

    return payload;
  };
  const mapDeleteTenant = (code: string) => {
    const payload = {
      code,
    } as DeleteTenantModel;

    return payload;
  };
  const mapCreatePerson = (form: PersonFormSchema) => {
    const payload = {
      tenant: form.tenant,
      role: form.role,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      username: form.username,
      email: form.email,
      password: form.password,
      is_verified: form.isVerified,
      avatar: form.avatar,
      gender: form.gender,
      birthday: formatDate(form.birthday as Date, undefined),
      is_blocked: form.isBlocked,
      mobile_number: form.mobileNumber,
      father_name: form.fatherName,
      mother_name: form.motherName,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      sss: form.sss,
      philhealth: form.philhealth,
      pagibig: form.pagibig,
      tin: form.tin,
      medical_condition: form.medicalCondition,
      blood_type: form.bloodType,
      elementary: form.elementary,
      high_school: form.highSchool,
      college: form.college,
      post_college: form.postCollege,
      undergraduate: form.undergraduate,
      curriculum_vitae: form.curriculumVitae,
      supporting_doc: form.supportingDoc,
      intent_letter: form.intentLetter,
      application_letter: form.applicationLetter,
      //   address: form.address,
    } as CreatePersonModel;

    const newPayload = {
      person: payload,
      file: form.photo,
    } as CreatePersonModelExtension;

    return newPayload;
  };
  const mapUpdatePerson = (form: PersonFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      role: form.role,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      username: form.username,
      email: form.email,
      password: form.password,
      is_verified: form.isVerified,
      avatar: form.avatar,
      gender: form.gender,
      birthday: formatDate(form.birthday as Date, undefined),
      is_blocked: form.isBlocked,
      mobile_number: form.mobileNumber,
      father_name: form.fatherName,
      mother_name: form.motherName,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      sss: form.sss,
      philhealth: form.philhealth,
      pagibig: form.pagibig,
      tin: form.tin,
      medical_condition: form.medicalCondition,
      blood_type: form.bloodType,
      elementary: form.elementary,
      high_school: form.highSchool,
      college: form.college,
      post_college: form.postCollege,
      undergraduate: form.undergraduate,
      curriculum_vitae: form.curriculumVitae,
      supporting_doc: form.supportingDoc,
      intent_letter: form.intentLetter,
      application_letter: form.applicationLetter,
      //   address: form.address,
    } as UpdatePersonModel;

    const newPayload = {
      person: payload,
      file: form.photo,
    } as UpdatePersonModelExtension;

    return newPayload;
  };
  const mapDeletePerson = (code: string) => {
    const payload = {
      code,
    } as DeletePersonModel;

    return payload;
  };
  const mapCreateRole = (form: RoleFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
    } as CreateRoleModel;

    return payload;
  };
  const mapUpdateRole = (form: RoleFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
    } as UpdateRoleModel;

    return payload;
  };
  const mapDeleteRole = (code: string) => {
    const payload = {
      code,
    } as DeleteRoleModel;

    return payload;
  };
  const mapCreateMember = (form: MemberFormSchema) => {
    const payload = {
      parent_code: form.parentCode,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      email: form.email,
      gender: form.gender,
      birthday: form.birthday ? formatDate(form.birthday as any, undefined) : undefined,
      mobile_number: form.mobileNumber,
      avatar: form.avatar,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      street_name: form.streetName,
      subdivision: form.subdivision,
      zone: form.zone,
      sitio: form.sitio,
      purok: form.purok,
      barangay: form.barangay,
      municipality: form.municipality,
      province: form.province,
      region: form.region,
      country: form.country,
      zip: form.zip,
      longitude: form.longitude,
      latitude: form.latitude,
      is_child: form.isChild,
      is_guardian: form.isGuardian,
    } as CreateMemberModel;

    const newPayload = {
      member: payload,
      file: form.photo,
    } as CreateMemberModelExtension;

    return newPayload;
  };
  const mapUpdateMember = (form: MemberFormSchema, code: string) => {
    const payload = {
      code,
      parent_code: form.parentCode,
      first_name: form.firstName,
      middle_name: form.middleName,
      last_name: form.lastName,
      email: form.email,
      gender: form.gender,
      birthday: form.birthday ? formatDate(form.birthday as any, undefined) : undefined,
      mobile_number: form.mobileNumber,
      avatar: form.avatar,
      emergency_contact_1_number: form.emergencyContact_1Number,
      emergency_contact_1_name: form.emergencyContact_1Name,
      emergency_contact_1_relationship: form.emergencyContact_1Relationship,
      emergency_contact_2_number: form.emergencyContact_2Number,
      emergency_contact_2_name: form.emergencyContact_2Name,
      emergency_contact_2_relationship: form.emergencyContact_2Relationship,
      street_name: form.streetName,
      subdivision: form.subdivision,
      zone: form.zone,
      sitio: form.sitio,
      purok: form.purok,
      barangay: form.barangay,
      municipality: form.municipality,
      province: form.province,
      region: form.region,
      country: form.country,
      zip: form.zip,
      longitude: form.longitude,
      latitude: form.latitude,
      is_child: form.isChild,
      is_guardian: form.isGuardian,
    } as UpdateMemberModel;

    const newPayload = {
      member: payload,
      file: form.photo,
    } as UpdateMemberModelExtension;

    return newPayload;
  };
  const mapDeleteMember = (code: string) => {
    const payload = {
      code,
    } as DeleteMemberModel;

    return payload;
  };
  const mapCreateTransactionService = (form: TransactionServiceFormSchema) => {
    const payload = {
      batch: form.batch,
      member: form.member,
      service: form.service,
      amount: form.amount,
      guardian: form.guardian,
    } as CreateTransactionServiceModel;

    const manilaNow = getDateTimeLocal(new Date(), "Asia/Manila");

    payload.date = form.date
      ? (typeof form.date === "string" ? form.date : formatDate(form.date))
      : format(manilaNow, "yyyy-MM-dd");
    payload.time = form.time ? form.time : format(manilaNow, "HH:mm");

    return payload;
  };
  const mapUpdateTransactionService = (
    form: TransactionServiceFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      member: form.member,
      service: form.service,
      amount: form.amount,
      guardian: form.guardian,
    } as UpdateTransactionServiceModel;

    if (form.date) {
      payload.date = typeof form.date === "string" ? form.date : formatDate(form.date);
    }

    if (form.time) {
      payload.time = form.time;
    }

    return payload;
  };
  const mapDeleteTransactionService = (code: string) => {
    const payload = {
      code,
    } as DeleteTransactionServiceModel;

    return payload;
  };
  const mapCreateTransactionAddon = (form: TransactionAddonFormSchema) => {
    const payload = {
      item: form.item,
      quantity: form.quantity,
      amount: form.amount,
    } as CreateTransactionAddonModel;

    if (form.batch) {
      payload.batch = form.batch;
    }

    return payload;
  };
  const mapUpdateTransactionAddon = (
    form: TransactionAddonFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      batch: form.batch,
      item: form.item,
      quantity: form.quantity,
      amount: form.amount,
    } as UpdateTransactionAddonModel;

    return payload;
  };
  const mapDeleteTransactionAddon = (code: string) => {
    const payload = {
      code,
    } as DeleteTransactionAddonModel;

    return payload;
  };

  const mapCreateTransaction = (form: TransactionFormSchema) => {
    const payload = {
      service: form.service?.map((item) => mapCreateTransactionService(item)),
      addon: form.addon?.map((item) => mapCreateTransactionAddon(item)),
      is_paid: form.isPaid,
    } as CreateTransactionModel;

    return payload;
  };

  const mapUpdateTransaction = (form: TransactionFormSchema, code: string) => {
    const payload = {
      code,
      service: form.service?.map((item) => mapCreateTransactionService(item)),
      addon: form.addon?.map((item) => mapCreateTransactionAddon(item)),
      is_paid: form.isPaid,
    } as UpdateTransactionModel;

    return payload;
  };
  const mapDeleteTransaction = (code: string) => {
    const payload = {
      code,
    } as DeleteTransactionModel;

    return payload;
  };
  const mapCreateItem = (form: ItemFormSchema) => {
    const payload = {
      name: form.name,
      description: form.description,
      amount: form.amount,
      tenant: form.tenant,
      duration: form.duration,
    } as CreateItemModel;

    return payload;
  };
  const mapUpdateItem = (form: ItemFormSchema, code: string) => {
    const payload = {
      code,
      name: form.name,
      description: form.description,
      amount: form.amount,
      tenant: form.tenant,
      duration: form.duration,
    } as UpdateItemModel;

    return payload;
  };
  const mapDeleteItem = (code: string) => {
    const payload = {
      code,
    } as DeleteItemModel;

    return payload;
  };
  const mapCreateWaiver = (form: WaiverFormSchema) => {
    const payload = {
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      font_size: form.fontSize,
      sub_title: form.subTitle,
    } as CreateWaiverModel;

    return payload;
  };
  const mapUpdateWaiver = (form: WaiverFormSchema, code: string) => {
    const payload = {
      code,
      tenant: form.tenant,
      name: form.name,
      description: form.description,
      font_size: form.fontSize,
      sub_title: form.subTitle,
    } as UpdateWaiverModel;

    return payload;
  };
  const mapDeleteWaiver = (code: string) => {
    const payload = {
      code,
    } as DeleteWaiverModel;

    return payload;
  };
  const mapCreateTransactionWaiver = (form: TransactionWaiverFormSchema) => {
    const payload = {
      code: form.batch,
      waiver: form.waiver,
      signature: form.signature,
    } as CreateTransactionWaiverModel;

    const newPayload = {
      waiver: payload,
      file: form.file,
    } as CreateTransactionWaiverModelExtension;

    return newPayload;
  };
  const mapUpdateTransactionWaiver = (
    form: TransactionWaiverFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      batch: form.batch,
      waiver: form.waiver,
      signature: form.signature,
    } as UpdateTransactionWaiverModel;

    const newPayload = {
      waiver: payload,
      file: form.file,
    } as UpdateTransactionWaiverModelExtension;

    return newPayload;
  };
  const mapDeleteTransactionWaiver = (code: string) => {
    const payload = {
      code,
    } as DeleteTransactionWaiverModel;

    return payload;
  };
  const mapCreateSubscription = (form: SubscriptionFormSchema) => {
    const payload = {
      tenant: form.tenant,
      member: form.member,
      service: form.service,
      start_date: form.startDate,
      end_date: form.endDate,
      amount: form.amount,
      is_subscription: form.isSubscription,
    } as CreateSubscriptionModel;

    return payload;
  };
  const mapUpdateSubscription = (
    form: SubscriptionFormSchema,
    code: string
  ) => {
    const payload = {
      code,
      tenant: form.tenant,
      member: form.member,
      service: form.service,
      start_date: form.startDate,
      end_date: form.endDate,
      amount: form.amount,
      is_subscription: form.isSubscription,
    } as UpdateSubscriptionModel;

    return payload;
  };
  const mapDeleteSubscription = (code: string) => {
    const payload = {
      code,
    } as DeleteSubscriptionModel;

    return payload;
  };
  // MAPPER FUNCTION

  return {
    mapLogin,
    mapCreateService,
    mapUpdateService,
    mapDeleteService,
    mapCreateTenant,
    mapUpdateTenant,
    mapDeleteTenant,
    mapCreatePerson,
    mapUpdatePerson,
    mapDeletePerson,
    mapCreateRole,
    mapUpdateRole,
    mapDeleteRole,
    mapCreateMember,
    mapUpdateMember,
    mapDeleteMember,
    mapCreateTransactionService,
    mapUpdateTransactionService,
    mapDeleteTransactionService,
    mapCreateTransactionAddon,
    mapUpdateTransactionAddon,
    mapDeleteTransactionAddon,
    mapCreateTransaction,
    mapUpdateTransaction,
    mapDeleteTransaction,
    mapCreateItem,
    mapUpdateItem,
    mapDeleteItem,
    mapCreateWaiver,
    mapUpdateWaiver,
    mapDeleteWaiver,
    mapCreateTransactionWaiver,
    mapUpdateTransactionWaiver,
    mapDeleteTransactionWaiver,
    mapCreateSubscription,
    mapUpdateSubscription,
    mapDeleteSubscription,
    // MAPPER RETURN
  };
}
